// 自定义字段 不能传入组件中，需要过滤
export const FIELD_FILTER_LIST = [
  'type',
  'attributes',
  'schemaNode',
  'hiddenOn',
  'customComponents',
  'contextDataCollection',
]
